/**
 * @generated SignedSource<<b231679c0b4abb5d667d5139fede2051>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designTemplatesQueriesSetShowTemplateSelectionMutation$variables = {
  modelID: string;
  showTemplateSelection: boolean;
};
export type designTemplatesQueriesSetShowTemplateSelectionMutation$data = {
  readonly setShowTemplateSelection: {
    readonly colors: ReadonlyArray<{
      readonly colorCode: string | null;
      readonly colorID: number;
      readonly name: string;
    }>;
    readonly id: string;
    readonly modelID: number;
    readonly name: string;
    readonly showTemplateSelection: boolean;
  };
};
export type designTemplatesQueriesSetShowTemplateSelectionMutation$rawResponse = {
  readonly setShowTemplateSelection: {
    readonly colors: ReadonlyArray<{
      readonly colorCode: string | null;
      readonly colorID: number;
      readonly name: string;
    }>;
    readonly id: string;
    readonly modelID: number;
    readonly name: string;
    readonly showTemplateSelection: boolean;
  };
};
export type designTemplatesQueriesSetShowTemplateSelectionMutation = {
  rawResponse: designTemplatesQueriesSetShowTemplateSelectionMutation$rawResponse;
  response: designTemplatesQueriesSetShowTemplateSelectionMutation$data;
  variables: designTemplatesQueriesSetShowTemplateSelectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showTemplateSelection"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelID",
        "variableName": "modelID"
      },
      {
        "kind": "Variable",
        "name": "showTemplateSelection",
        "variableName": "showTemplateSelection"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "setShowTemplateSelection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "showTemplateSelection",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Color",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorCode",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesSetShowTemplateSelectionMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "designTemplatesQueriesSetShowTemplateSelectionMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "bd708416da4bca4afffa91490d6be924",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesSetShowTemplateSelectionMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesSetShowTemplateSelectionMutation(\n  $modelID: ID!\n  $showTemplateSelection: Boolean!\n) {\n  setShowTemplateSelection(modelID: $modelID, showTemplateSelection: $showTemplateSelection) {\n    id\n    modelID\n    name\n    showTemplateSelection\n    colors {\n      colorID\n      name\n      colorCode\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "60a9fda734df498a721b133eccd42f64";

export default node;
